import { Action } from '@ngrx/store';
import { IShippingDestination } from '@cemex-core/cmx-api/models/destinations/shipping-destination';
import { Order } from '@cemex-core/cmx-api';

export enum OneClickPointOfDeliveriesActionTypes {
  LOAD_PODS = '[One Click] Load point of deliveries',
  PRELOAD_POD = '[One Click] Preload point of delivery',
  LOAD_PODS_COMPLETE = '[One Click] Load point of deliveries completed',
  SELECT_POD = '[One Click] Select point of delivery',
  RESET = '[One Click] Point of deliveries reset',
}

export class OneClickLoadPointOfDeliveriesAction implements Action {
  readonly type = OneClickPointOfDeliveriesActionTypes.LOAD_PODS;

  constructor() {}
}

export class OneClickPreLoadPointOfDeliveriesAction implements Action {
  readonly type = OneClickPointOfDeliveriesActionTypes.PRELOAD_POD;

  constructor(public payload: Order) {}
}

export class OneClickLoadPointOfDeliveriesCompleteAction implements Action {
  readonly type = OneClickPointOfDeliveriesActionTypes.LOAD_PODS_COMPLETE;

  constructor(public payload: IShippingDestination[]) {}
}

export class OneClickSelectPointOfDeliveriesAction implements Action {
  readonly type = OneClickPointOfDeliveriesActionTypes.SELECT_POD;

  constructor(public payload: IShippingDestination) {}
}

export class OneClickResetPointOfDeliveriesAction implements Action {
  readonly type = OneClickPointOfDeliveriesActionTypes.RESET;

  constructor() {}
}

export type OneClickPointOfDeliveryActions =
  | OneClickLoadPointOfDeliveriesAction
  | OneClickPreLoadPointOfDeliveriesAction
  | OneClickLoadPointOfDeliveriesCompleteAction
  | OneClickSelectPointOfDeliveriesAction
  | OneClickResetPointOfDeliveriesAction;
